/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SlotTrigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CalendarSlot from 'DesignSystem/Svgs/Tysiav2CalendarSlot/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SlotTrigger({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/ScheduleOptions/Content/SlotSelect/Content/SlotTrigger"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let daySlotsSlotsValueData = fromData.useDataValue({ viewPath,
context: 'day_slots',
path: 'slots',
})
let tabSchedulingSlotIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.slot_id',
})
let tabSchedulingUntemplatedSlotValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.untemplated_slot',
})
let aggregateData = fromHelpers.getSlotLabel(daySlotsSlotsValueData, tabSchedulingSlotIdValueData, tabSchedulingUntemplatedSlotValueData)
  return (<React.Fragment
>
<div
  data-testid="SlotTrigger.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-ZQeXdw': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CalendarSlot
  viewPath={`${viewPath}/Tysiav2CalendarSlot`}
 width={12}
 height={12}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="small"
 data="day_slots.slots"
 data="tab.scheduling.slot_id"
 data="tab.scheduling.untemplated_slot"
 aggregate="helpers.js getSlotLabel"
 text={aggregateData}
/>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 height={14}
 width={14}
 fill={dtColorsNeutral400}
/>
</div>
{children}
</React.Fragment>)
}